import React from 'react';

export const UserComments = React.lazy(() => import('./UserComments'));
